import "./SetupDropDown.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAtom, useSetAtom } from "jotai";
import {
  globalCurrentPageTitle,
  paymentTypeAtom,
} from "../../../../store/globalstore";
import {
  resetOnBoardingStartContext,
  setOnBoardingStartContext,
} from "../../../../redux/users/usersSlice";
import Arrow from "../../../../assets/images/rightAnglePath.svg";
import { toastify } from "../../../../helpers/toast/toastify";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const SetupDropdown = ({ buttonText }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPageTitle, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle,
  );
  const [buttonTextOnboarindg, setButtonTextOnboarding] = useState(
    "Launch Copy Trading Service",
  );
  const dropdownRef = useRef(null);
  const setPaymentType = useSetAtom(paymentTypeAtom);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext,
  );
  const location = useLocation();
  const subscription = user?.verifiedmyTrade?.subscription;
  const hasActiveSubscription =
    subscription?.active && subscription.originalName;
  const isConnected =
    user?.binanceCredentials?.isConnected ||
    user?.bybitCredentials?.isConnected;
  useEffect(() => {
    if (user?.role === "leader") {
      const isOnBoardingComplete =
        user?.onboarding?.isCommunityCreated &&
        user?.onboarding?.connect &&
        user?.onboarding?.payment &&
        user?.onboarding?.subscribed &&
        user?.onboarding?.isVerified;

      if (user?.onboarding?.isCommunityCreated && !isOnBoardingComplete) {
        setButtonTextOnboarding("Start Copy Trade (Continue)");
      }

      if (isOnBoardingComplete) {
        setButtonTextOnboarding("Launch Extra Copy Trading Service");
      }
    } else if (user?.role === "member") {
      if (user?.onboarding?.payment) {
        setButtonTextOnboarding("Start Copy Trade (Continue)");
      }
    }
  }, [user]);

  const handleClose = () => {
    if (onBoardingStartContext) {
      handleOptionClick();
      dispatch(resetOnBoardingStartContext());
      return;
    }
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target))
      setIsOpen(false);
  };

  const handleOptionClick = () => setIsOpen(false);
  const toggleDropdown = () => {
    const isOnBoardingComplete =
      user?.onboarding?.isCommunityCreated &&
      user?.onboarding?.connect &&
      user?.onboarding?.payment &&
      user?.onboarding?.subscribed &&
      user?.onboarding?.isVerified;
    if (user?.onboarding?.isCommunityCreated && !isOnBoardingComplete) {
      if (user?.role === "leader") {
        if (!user?.onboarding?.isCommunityCreated) {
          dispatch(setOnBoardingStartContext(location.pathname));
          navigate("/leader/onboarding/community", { replace: true });
          return;
        }

        if (!user?.onboarding?.connect) {
          dispatch(setOnBoardingStartContext(location.pathname));
          navigate("/leader/onboarding/connection", { replace: true });
          return;
        }

        if (!user?.onboarding?.subscribed) {
          dispatch(setOnBoardingStartContext(location.pathname));
          navigate("/leader/onboarding/subscription");
          return;
        }

        if (!user?.onboarding?.payment) {
          dispatch(setOnBoardingStartContext(location.pathname));
          navigate("/leader/onboarding/payout");
          return;
        }

        if (!user?.onboarding?.isVerified) {
          if (
            user?.socialLogin?.discord?.id ||
            user?.socialLogin?.telegram?.id
          ) {
            dispatch(setOnBoardingStartContext(location.pathname));
            navigate("/leader/onboarding/importantUpdates", { replace: true });
          } else {
            dispatch(setOnBoardingStartContext(location.pathname));
            navigate("/leader/onboarding/verify", { replace: true });
          }
          return;
        }
        dispatch(setOnBoardingStartContext(location.pathname));
        navigate("/leader/onboarding/community");
      } else if (user?.role === "member") {
        if (!user?.onboarding?.payment) {
          navigate("/member/onboarding/subscription");
          return;
        }

        if (!user?.onboarding?.connect) {
          navigate("/member/onboarding/connection");
          return;
        }

        navigate("/member/dashboard");
      }
    } else if (user?.role === "leader") {
      if (
        user?.tradeName &&
        !user?.verifiedmyTrade.payment &&
        !user?.verifiedmyTrade.subscription.subscriptionId &&
        !user?.leaderCommunity
      ) {
        navigate("/leader/verifymyTrade/tradeinfo");
        dispatch(setOnBoardingStartContext(location.pathname));
        return;
      } else if (!user?.tradeName && !user?.leaderCommunity) {
        navigate("/leader/onboarding/community");
        dispatch(setOnBoardingStartContext(location.pathname));
      }
    } else {
      if (user?.role === "member") {
        if (!user?.onboarding?.payment && user?.onboarding?.connect) {
          setCurrentPageTitle("");
          navigate("/member/onboarding/subscription");
          return;
        }

        if (!user?.onboarding?.connect) {
          navigate("/member/onboarding/view");
          return;
        }

        toastify("You onboarding steps are complete", "success");
        navigate("/member/dashboard");
        return;
      }
    }

    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // Lock body scroll on mobile when dropdown is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("mobile-scroll-locked");
    } else {
      document.body.classList.remove("mobile-scroll-locked");
    }
    return () => {
      document.body.classList.remove("mobile-scroll-locked");
    };
  }, [isOpen]);

  const handleOnboarding = () => {
    if (user?.role === "leader") {
      if (!user?.onboarding?.isCommunityCreated) {
        dispatch(setOnBoardingStartContext(location.pathname));
        navigate("/leader/onboarding/community", { replace: true });
        return;
      }

      if (!user?.onboarding?.connect) {
        dispatch(setOnBoardingStartContext(location.pathname));
        navigate("/leader/onboarding/connection", { replace: true });
        return;
      }

      if (!user?.onboarding?.subscribed) {
        dispatch(setOnBoardingStartContext(location.pathname));
        navigate("/leader/onboarding/subscription");
        return;
      }

      if (!user?.onboarding?.payment) {
        dispatch(setOnBoardingStartContext(location.pathname));
        navigate("/leader/onboarding/payout");
        return;
      }

      if (!user?.onboarding?.isVerified) {
        if (user?.socialLogin?.discord?.id || user?.socialLogin?.telegram?.id) {
          dispatch(setOnBoardingStartContext(location.pathname));
          navigate("/leader/onboarding/importantUpdates", { replace: true });
        } else {
          dispatch(setOnBoardingStartContext(location.pathname));
          navigate("/leader/onboarding/verify", { replace: true });
        }
        return;
      }
      dispatch(setOnBoardingStartContext(location.pathname));
      navigate("/leader/onboarding/community");
    } else if (user?.role === "member") {
      if (!user?.onboarding?.payment) {
        navigate("/member/onboarding/subscription");
        return;
      }

      if (!user?.onboarding?.connect) {
        navigate("/member/onboarding/connection");
        return;
      }

      navigate("/member/onboarding/view");
    }
  };
  const handleVerifyMyTrade = () => {
    handleOptionClick();
    dispatch(setOnBoardingStartContext(location.pathname));
    navigate("/leader/verifymyTrade/tradeinfo", { replace: true });
  };

  return (
    <div className="setup-dropdown" ref={dropdownRef}>
      <div className="mobileDisplay">    
        <BubbleSvgButton
          className={`createBtnSM  ${isOpen ? "active" : ""}`}
          onClick={toggleDropdown}
          text="+"
          type="button"
          variant="green"
          containerStyling={{
            justifyContent: "center",
          }}
          mainDivStyle={{
            width: "auto",
            height: "auto",  
          }}
        />
        {/* <button
          className={`createBtnSM  ${isOpen ? "active" : ""}`}
          
          type="button"
        >
          +
        </button> */}
      </div>
      <div className="desktopOnly">
        <BubbleSvgButton
          className={`createBtn  ${isOpen ? "active" : ""}`}
          onClick={toggleDropdown}
          text={buttonText}
          type="button"
          variant="green"
          containerStyling={{
            justifyContent: "center",
          }}
          mainDivStyle={{
            width: "auto",
            height: "auto",  
          }}
        />
        {/* <button
          
          onClick={toggleDropdown}
          type="button"
        >
          
        </button> */}
      </div>
      {isOpen && (
        <ul className="dropdown-menu" style={{ top: "50px" }}>
          <li onClick={handleVerifyMyTrade}>
            <span className="setup-dropdown__label">
              {user?.verifiedmyTrade?.payment ? "Verify Again" : "Verify A Trade"}
            </span>
            <img alt="Arrow" src={Arrow} />
          </li>
          <li onClick={handleOnboarding}>
            <span className="setup-dropdown__label">{buttonTextOnboarindg}</span>
            <img alt="Arrow" src={Arrow} />
          </li>
        </ul>
      )}
    </div>
  );
};

export default SetupDropdown;
